import { ItemClassificationType } from './items.models';

export interface DisputeRequest {
  disputeRequestEntityId: string;
  disputeRequestId: string;
  status: DisputeRequestStatus | null;
  itemsTotal: number | null;
  requesterEntityId: string | null;
  requester: string | null;
  requestedDate: string | Date | null;
  completedDate: string | Date | null;
  requestComment: string | null;
}

export interface DisputeRequestDetails {
  disputeRequestEntityId: string;
  disputeRequestId: string;
  status: DisputeRequestStatus | null;
  requestComment: string | null;
  requesterEntityId: string | null;
  requester: string | null;
  requesterEmailAddress: string | null;
  requestedDate: string | Date | null;
  completedDate: string | Date | null;

  statistics: DisputeRequestItemStatusCount[];
}

export interface DisputeRequestItemStatusCount {
  status: DisputeRequestItemStatus;
  count: number;
}

export enum DisputeRequestStatus {
  Initiating = 1,
  Submitted = 2,
  InProgress = 3,
  Completed = 4,
}

export enum DisputeRequestItemStatus {
  Submitted = 0,
  InProgress = 1,
  Agreed = 2,
  InReclassification = 3,
  Disagreed = 4,
  Reclassified = 5,
  Cancelled = 6,
}

export enum DisputeInitiator {
  CustomsBroker = 0,
  ClientUser = 1,
  EYUser = 2,
}

export function getDisputeRequestStatusName(status: DisputeRequestStatus | null): string {
  switch (status) {
    case DisputeRequestStatus.Initiating:
      return 'dispute-requests.status.initiating';
    case DisputeRequestStatus.Submitted:
      return 'dispute-requests.status.submitted';
    case DisputeRequestStatus.InProgress:
      return 'dispute-requests.status.in-progress';
    case DisputeRequestStatus.Completed:
      return 'dispute-requests.status.completed';
    default:
      return 'dispute-requests.status.unknown';
  }
}

export function getDisputeRequestItemStatusName(status: DisputeRequestItemStatus | null): string {
  switch (status) {
    case DisputeRequestItemStatus.Submitted:
      return 'dispute-requests.item-status.submitted';
    case DisputeRequestItemStatus.InProgress:
      return 'dispute-requests.item-status.in-progress';
    case DisputeRequestItemStatus.Agreed:
      return 'dispute-requests.item-status.agreed';
    case DisputeRequestItemStatus.InReclassification:
      return 'dispute-requests.item-status.in-reclassification';
    case DisputeRequestItemStatus.Disagreed:
      return 'dispute-requests.item-status.disagreed';
    case DisputeRequestItemStatus.Reclassified:
      return 'dispute-requests.item-status.reclassified';
    case DisputeRequestItemStatus.Cancelled:
      return 'dispute-requests.item-status.cancelled';
    default:
      return 'dispute-requests.item-status.unknown';
  }
}

export interface DisputeItem {
  disputeItemEntityId: string | null;
  disputeItemId: string | null;
  requestEntityId: string | null;
  requestId: string | null;
  itemEntityId: string | null;
  itemId: string | null;
  productId: string | null;
  description: string | null;
  itemClassificationType: ItemClassificationType | null;
  country: string | null;
  classificationCode: string | null;
  suggestedCode: string | null;
  agreedCode: string | null;
  status: DisputeRequestItemStatus | null;
  disputeRationale: string | null;
  reclassificationItemId: string | null;
  completedDate: string | Date | null;
  subdivisionName: string | null;
}

export interface DisputeItemComment {
  contactEntityId: string | null;
  userEntityId: string | null;
  authorFullName: string;
  createdOn: Date | string;
  comment: string;
}

export interface DisputeItemDetails {
  disputeItemEntityId: string | null;
  disputeItemId: string | null;
  disputeRequestId: string | null;
  status: DisputeRequestItemStatus | null;
  requester: string | null;
  requesterEmail: string | null;
  disputeInitiator: DisputeInitiator | null;
  requestedDate: string | Date | null;
  completedDate: string | Date | null;
  productId: string | null;
  description: string | null;
  country: string | null;
  classificationType: ItemClassificationType | null;
  subdivision: string | null;
  itemId: string | null;
  classificationCode: string | null;
  suggestedCode: string | null;
  agreedCode: string | null;
  reclassificationItemId: string | null;
  disputeRationale: string | null;
}

export function getDisputeInitiatorName(name: DisputeInitiator | null): string {
  switch (name) {
    case DisputeInitiator.CustomsBroker:
      return 'dispute-item-details.dispute-initiator.customs-broker';
    case DisputeInitiator.ClientUser:
      return 'dispute-item-details.dispute-initiator.client-user';
    case DisputeInitiator.EYUser:
      return 'dispute-item-details.dispute-initiator.ey-user';
    default:
      return 'dispute-item-details.dispute-initiator.unknown';
  }
}
